import Approutes from "../Routes"
function PageContent() {
  return (
  <div className='pageContent'>
    <Approutes/>
  </div>
  );
}
export default PageContent